export interface Store {
  id: number
  name: string
  address: string
  phone: string
  hours?: string
  lat?: number
  lng?: number
}

export const stores: Store[] = [
  {
    id: 1,
    name: "129A Bình Quới",
    address: "129A Bình Quới, P.27, Q.Bình Thạnh, Thành phố Hồ Chí Minh",
    phone: "0707903937",
  },
  {
    id: 2,
    name: "376 Nguyễn Kiệm",
    address: "376 Nguyễn Kiệm, P.3, Q.Phú Nhuận, Thành phố Hồ Chí Minh",
    phone: "0396809945",
  },
  {
    id: 3,
    name: "202 Đường Số 8",
    address: "202 Đường Số 8, P.11, Q.Gò Vấp, Thành phố Hồ Chí Minh",
    phone: "0386179601",
  },
  {
    id: 4,
    name: "711 Phan Văn Trị",
    address: "711 Phan Văn Trị, P.7, Q.Gò Vấp, Thành phố Hồ Chí Minh",
    phone: "0386179601",
  },
  {
    id: 5,
    name: "71 Ngô Tất Tố",
    address: "71 Ngô Tất Tố, P.21, Q.Bình Thạnh, Thành phố Hồ Chí Minh",
    phone: "0708916541",
  },
  {
    id: 7,
    name: "200 Vạn Kiếp",
    address: "200 Vạn Kiếp, P.3, Q.Bình Thạnh, Thành phố Hồ Chí Minh",
    phone: "0396809945",
  },
  {
    id: 8,
    name: "34C Tân Quý",
    address: "34C Tân Quý, P.Tân Quý, Q.Tân Phú, Thành phố Hồ Chí Minh",
    phone: "0398572592",
  },
  {
    id: 9,
    name: "39 Đồng Đen",
    address: "39 Đồng Đen, P.12, Q.Tân Bình, Thành phố Hồ Chí Minh",
    phone: "0398572592",
  },
  {
    id: 10,
    name: "71A Nguyễn Văn Quá",
    address:
      "71A Nguyễn Văn Quá, P.Tân Hưng Thuận, Quận 12, Thành phố Hồ Chí Minh",
    phone: "0395171510",
  },
  {
    id: 11,
    name: "712 Lạc Long Quân",
    address: "712 Lạc Long Quân, P.9, Q.Tân Bình, Thành phố Hồ Chí Minh",
    phone: "0377920938",
  },
  {
    id: 12,
    name: "39/50 Đặng Thuỳ Trâm",
    address: "39/50 Đặng Thùy Trâm, P.13, Q.Bình Thạnh, Thành phố Hồ Chí Minh",
    phone: "0823684518",
  },
  {
    id: 13,
    name: "1/3 Quang Trung",
    address:
      "1/3 Quang Trung, TT Hóc Môn, Huyện Hóc Môn, Thành phố Hồ Chí Minh",
    phone: "0785779488",
  },
  {
    id: 14,
    name: "329 Tỉnh Lộ 10",
    address: "329 Tỉnh Lộ 10, P. An Lạc, Q.Bình Tân, Thành phố Hồ Chí Minh",
    phone: "0565232814",
  },
  {
    id: 15,
    name: "77A - 77B Hiệp Bình",
    address:
      "77A - 77B Hiệp Bình, P. Hiệp Bình Phước, TP. Thủ Đức, Thành phố Hồ Chí Minh",
    phone: "0708916541",
  },
  {
    id: 16,
    name: "168A Nguyễn Duy Trinh",
    address:
      "168A Nguyễn Duy Trinh, P. Bình Trưng Tây, TP. Thủ Đức, Thành phố Hồ Chí Minh",
    phone: "0974613131",
  },
  {
    id: 17,
    name: "376D Cách Mạng Tháng 8",
    address: "376D Cách Mạng Tháng Tám, P.10, Quận 3, Thành phố Hồ Chí Minh",
    phone: "0327725382",
  },
  {
    id: 18,
    name: "38A Đường số 17",
    address:
      "38A Đường Số 17, P. Linh Chiểu, TP. Thủ Đức, Thành phố Hồ Chí Minh",
    phone: "0963858722",
  },
  {
    id: 19,
    name: "65 Trường Sơn",
    address: "65 Trường Sơn, Phường 2, Q.Tân Bình, Thành phố Hồ Chí Minh",
    phone: "0327725382",
  },
  {
    id: 20,
    name: "275 Đỗ Xuân Hợp",
    address:
      "275 Đỗ Xuân Hợp, P. Phước Long B, TP. Thủ Đức, Thành phố Hồ Chí Minh",
    phone: "0974613131",
  },
  {
    id: 21,
    name: "59 Đường số 3",
    address: "59 Đường Số 3, P. An Khánh, TP. Thủ Đức, Thành phố Hồ Chí Minh",
    phone: "0708916541",
  },
  {
    id: 22,
    name: "372 Nguyễn Tri Phương",
    address: "372 Nguyễn Tri Phương, P.4, Quận 10, Thành phố Hồ Chí Minh",
    phone: "0934794164",
  },
  {
    id: 23,
    name: "98 Vĩnh Hội",
    address: "98 Vĩnh Hội, Phường 4, Quận 4, Thành phố Hồ Chí Minh",
    phone: "0921541250",
  },
  {
    id: 24,
    name: "572 Lê Văn Quới",
    address:
      "572 Lê Văn Quới, P.Bình Hưng Hòa A, Q.Bình Tân, Thành phố Hồ Chí Minh",
    phone: "0565232814",
  },
  {
    id: 25,
    name: "26 Đường số 17, Quận 7",
    address: "26 Đường Số 17, P. Tân Kiểng, Quận 7, Thành phố Hồ Chí Minh",
    phone: "0364490195",
  },
  {
    id: 26,
    name: "45 Man Thiện",
    address: "45 Man Thiện, P. Hiệp Phú, TP. Thủ Đức, Thành phố Hồ Chí Minh",
    phone: "0963858722",
  },
  {
    id: 27,
    name: "45 Đặng Chất",
    address: "45 Đặng Chất, P.3, Quận 8, Thành phố Hồ Chí Minh",
    phone: "0949847726",
  },
  {
    id: 29,
    name: "486A Hồ Học Lãm",
    address: "486A Hồ Học Lãm, P. An Lạc, Q.Bình Tân, Thành phố Hồ Chí Minh",
    phone: "0565232814",
  },
  {
    id: 30,
    name: "55 Bùi Văn Ba",
    address: "55 Bùi Văn Ba, Phường Tân Thuận, Quận 7, Thành phố Hồ Chí Minh",
    phone: "0364490195",
  },
  {
    id: 31,
    name: "Quốc Lộ 50",
    address: "637 Quốc lộ 50, xã Bình Hưng, Thành phố Hồ Chí Minh",
    phone: "0934794164",
  },
  {
    id: 32,
    name: "34 Nguyễn Ảnh Thủ",
    address: "34 Nguyễn Ảnh Thủ P. Hiệp Thành, Quận 12, Thành phố Hồ Chí Minh",
    phone: "0395171510",
  },
]
